import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import { Overlay, Tooltip } from "react-bootstrap"

import "app/static/stylus/tooltip-i.styl"

const OverflowAwareTooltip = (props) => {
    const [showTooltip, setShowTooltip] = useState(false)
    const target = useRef(null)

    const handleMouseOver = () => {
        if (target && target.current && target.current.offsetWidth < target.current.scrollWidth) {
            setShowTooltip(true)
        }
    }

    const handleMouseOut = () => showTooltip && setShowTooltip(false)

    const renderTarget = () => {
        const LabelComponent = props.labelComponent

        return (
            <LabelComponent className={props.labelClass} ref={target} {...props}>
                {props.label}
            </LabelComponent>
        )
    }

    const WrapperComponent = props.wrapperComponent

    return (
        <div
            onBlur={handleMouseOver}
            onMouseOut={handleMouseOut}
            onFocus={handleMouseOver}
            onMouseOver={handleMouseOver}
        >
            <Overlay
                container={this}
                target={target}
                show={showTooltip}
                placement={props.placement}
                delayShow={props.delayShow}
                style={props.tooltipStyle}
            >
                <Tooltip style={props.tooltipStyle}>{props.label}</Tooltip>
            </Overlay>
            <WrapperComponent className={props.wrapperComponentClass} {...props}>
                {renderTarget()}
            </WrapperComponent>
        </div>
    )
}

OverflowAwareTooltip.propTypes = {
    label: PropTypes.string.isRequired,
    wrapperComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    labelComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    wrapperDivClass: PropTypes.string,
    labelClass: PropTypes.string,
    wrapperComponentClass: PropTypes.string,
    placement: PropTypes.string,
    delayShow: PropTypes.number,
    tooltipStyle: PropTypes.object,
}

OverflowAwareTooltip.defaultProps = {
    delayShow: 150,
    placement: "top",
    labelComponent: "span",
    wrapperComponent: "div",
}

export default OverflowAwareTooltip
